export default "__VITE_ASSET__DMlYAUbI__"